import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { getApiDataService } from "../../../services/apiServices";
import { REGION_API } from "../../../services/CONSTANTS";
import { PAYMENT_TYPES } from "../../../config/AppConfig";

function EditPaymentProviderModal(props) {
  // Initialize state with default values for accountName, accountNo, and status
  const [name, setName] = useState(props?.item?.name);
  const [paymentType, setPaymentType] = useState(props?.item?.payment_type);
  const [regionId, setRegionId] = useState(props?.item?.region_id);
  const [logo, setLogo] = useState(null);
  const [preview, setPreview] = useState(props?.item?.logo);
  const [status, setStatus] = useState(props?.item?.status);

  const [regions, setRegions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchRegions();
  }, []);

  const fetchRegions = () => {
    setIsLoading(true);
    getApiDataService(REGION_API)
      .then((response) => {
        setRegions(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };
  const handlePaymentTypeChange = (event) => {
    setPaymentType(event.target.value);
  };
  const handleRegionChange = (event) => {
    setRegionId(event.target.value);
  };
  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };
  const handleLogoChange = (e) => {
    // setLogo(e.target.value);
    if (
      e.target.files[0].type === "image/jpeg" ||
      e.target.files[0].type === "image/png" ||
      e.target.files[0].type === "image/jpg"
    ) {
      let imgReview = e.target.files[0];
      console.log(imgReview);
      if (imgReview) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreview(reader.result);
        };
        reader.readAsDataURL(imgReview);
      } else {
        setPreview(null);
      }
      setLogo(e.target.files[0]);
    } else {
      alert("This is only accept image files! Thanks");
      setLogo(null);
      return;
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    let form_data = new FormData();
    form_data.append("name", name);
    form_data.append("payment_type", paymentType);
    form_data.append("region_id", regionId);
    logo && form_data.append("logo", logo);
    form_data.append("status", status);
    props.onSubmit(form_data, setIsLoading);
  };

  return (
    <Modal isOpen={true} toggle={props.onClose}>
      <ModalHeader toggle={props.onClose}>
        <h4>Edit Payment Provider</h4>
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="status">Region</Label>
            <Input
              type="select"
              name="region"
              onChange={handleRegionChange}
              value={regionId}
            >
              {regions.map((region) => {
                return <option value={region.id}>{region.country_name}</option>;
              })}
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="accountName">Name</Label>
            <Input
              type="text"
              name="accountName"
              id="accountName"
              onChange={handleNameChange}
              value={name}
            />
          </FormGroup>
          <FormGroup>
            <Label for="logo">Logo</Label>
            <Input
              type="file"
              accept="image/png, image/gif, image/jpeg"
              name="logo"
              id="logo"
              onChange={handleLogoChange}
            />
          </FormGroup>
          <img
            src={preview}
            alt=""
            style={{ width: "100px", height: "100px" }}
          />
          <FormGroup>
            <Label for="status"> Payment Type</Label>
            <Input
              type="select"
              name="paymentType"
              onChange={handlePaymentTypeChange}
              value={paymentType}
            >
              {PAYMENT_TYPES.map((paymentType) => {
                return <option value={paymentType}>{paymentType}</option>;
              })}
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="status">Status</Label>
            <Input
              type="select"
              name="paymentType"
              onChange={handleStatusChange}
              value={status}
            >
              <option value="active">active</option>
              <option value="disable">disable</option>
            </Input>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-default" onClick={props.onClose}>
          No
        </button>
        {props?.isLoading == false && (
          <button className="btn btn-success" onClick={handleSubmit}>
            Save
          </button>
        )}
        {props?.isLoading == true && (
          <button className="btn btn-success" disabled="disabled">
            Uploading...
          </button>
        )}
      </ModalFooter>
    </Modal>
  );
}

export default EditPaymentProviderModal;
